import React from 'react';

const WarningIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px">
    <path
      fill="#f3c629"
      d="M4.32 21a2.86 2.86 0 0 1-2.5-1.45 2.49 2.49 0 0 1 0-2.49L9.53 4.34a3 3 0 0 1 .89-.88 2.93 2.93 0 0 1 4 .89l7.67 12.71a2.51 2.51 0 0 1 0 2.54A2.89 2.89 0 0 1 19.7 21z"
    />
    <path
      fill="#c19d21"
      d="M12 3.5a2.42 2.42 0 0 1 2 1.1l7.7 12.72a2 2 0 0 1 0 2 2.38 2.38 0 0 1-2.08 1.17H4.31a2.37 2.37 0 0 1-2-1.18 2 2 0 0 1 0-2L10 4.62a2.49 2.49 0 0 1 .74-.74A2.4 2.4 0 0 1 12 3.5m0-1a3.36 3.36 0 0 0-1.85.5A3.47 3.47 0 0 0 9.1 4L1.43 16.8a3 3 0 0 0-.05 3 3.38 3.38 0 0 0 2.93 1.7H19.7a3.36 3.36 0 0 0 2.9-1.66 3 3 0 0 0-.05-3L14.88 4.08A3.42 3.42 0 0 0 12 2.5z"
    />
    <circle fill="#333" cx="11.99" cy="16.5" r="1" />
    <path fill="#333" d="M13 13.5a1 1 0 0 1-2 0v-4a1 1 0 0 1 2 0z" />
  </svg>
);

export default WarningIcon;
